"use client";

import { useTranslations } from "next-intl";
import { useState } from "react";
import { LuChevronRight } from "react-icons/lu";

import { Button } from "@/components/ui/button";
import { Dialog, DialogClose, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Typography } from "@/components/ui/typography";

interface ISettingsWrapperProps {
    children?: React.ReactNode;
    headerLabel?: string;
    currentValue?: string;
    options?: { value: string; label: string }[];
    onSelect?: (option: string) => void;
    isDialog?: boolean;
}

export const ProfileWrapper = ({ children, headerLabel, currentValue, options, onSelect, isDialog }: ISettingsWrapperProps) => {
    const t = useTranslations("profile");

    const [ selectedValue, setSelectedValue ] = useState<string | null>(null);
    const currentLabel = options?.find(option => option.value === currentValue)?.label || currentValue;

    const handleSave = () => {
        if (onSelect && selectedValue) {
            onSelect(selectedValue);
        }
    };

    return isDialog && options && onSelect ? (
        <Dialog>
            <DialogTrigger asChild onClick={ () => setSelectedValue(null) }>
                <div className="flex cursor-pointer items-center justify-between gap-2">
                    <div className="flex flex-col gap-1">
                        {headerLabel ? <Typography variant="base">{headerLabel}</Typography> : null}
                        <Typography variant="base" className="text-primary">
                            {currentLabel}
                        </Typography>
                    </div>
                    <LuChevronRight className="size-6" />
                </div>
            </DialogTrigger>
            <DialogContent className="p-7">
                <DialogHeader>
                    <DialogTitle className="hidden">{headerLabel}</DialogTitle>
                    {options.map(option => (
                        <Button
                            key={ option.value }
                            variant="ghost"
                            onClick={ () => setSelectedValue(option.value) }
                            className={ `text-left ${ option.value === currentValue ? "text-primary" : "" }  ${ selectedValue === option.value ? "bg-accent" : "" }` }
                        >
                            {option.label}
                        </Button>
                    ))}
                    <div className="flex justify-end">
                        <DialogClose asChild>
                            <Button variant="success" onClick={ handleSave }>
                                {t("save")}
                            </Button>
                        </DialogClose>
                    </div>
                    <DialogDescription className="hidden"></DialogDescription>
                </DialogHeader>
            </DialogContent>
        </Dialog>
    ) : (
        <div className="flex cursor-pointer items-center justify-between gap-2">
            <div className="flex flex-col gap-1">
                <Typography variant="base">{headerLabel}</Typography>
                {currentLabel ? (
                    <Typography variant="base" className="text-primary">
                        {currentLabel}
                    </Typography>
                ) : null}
            </div>
            <LuChevronRight className="size-6" />
            {/* TODO: Show children after clicking */}
            {children}
        </div>
    );
};
